import $ from "jquery";
window.$ = $;
window.jQuery = $;

export function inline_edit() {
  $.fn.editable.defaults.mode = "inline";

  $.fn.editableform.buttons =
    '<button type="submit" class="editable-submit button-icon button-icon-success ms-1 me-1" style="cursor: pointer;">' +
    '<i class="fas fa-check-circle"></i>' +
    "</button>";

  $(".editable-field").each(function () {
    const $el = $(this);

    if ($el.data("editable-initialized")) return;
    $el.data("editable-initialized", true);
    window.alert = function (message) {
      console.trace("ALERT intercepté:", message);
    };
    const fieldType = $el.data("type") || "text";
    const fieldSource = $el.data("source");
    const emptyText = $el.data("emptytext") || "";
    const inputClass = "preference_columns";

    const options = {
      type: fieldType,
      name: $el.data("name"),
      pk: $el.data("pk"),
      value: $el.data("value"),
      url: $el.data("url"),
      emptytext: emptyText,
      inputclass: inputClass,
      savenochange: true,
      success: function (response, newValue) {
        $("#fx-conteneur-error").remove();
        $("#fx-conteneur-notice").remove();

        const message = response?.message || "Modifié avec succès";

        const $flash = $(`
          <div id="fx-conteneur-notice" class="fx-flash-top-right fx-flash-success fx-flash-message"
               data-controller="flash"
               data-flash-target="container"
               data-flash-timeout-value="3500"
               data-action="mouseenter->flash#mouseenter mouseleave->flash#mouseleave">
            <button class="fx-flash-close-button" data-action="flash#dismissManually">&times;</button>
            <div class="fx-inline-message">
              
              <span>${message}</span>
            </div>
            <div class="fx-progress-bar" data-flash-target="progressBar"></div>
          </div>
        `);

        $("body").append($flash);

        setTimeout(() => {
          $flash.fadeOut(500, () => $flash.remove());
        }, 5000);
      },

      error: function (xhr, status, errorThrown) {
        let message = "Erreur inconnue";
      
        try {
          const json = JSON.parse(xhr.responseText);
          if (json.errors) {
            message = Array.isArray(json.errors)
              ? "<div class='fx-d-inline-block'>" +
                  json.errors
                    .map(
                      (msg) =>
                        `<div class='fx-inline-message'><span class='fx-chip'></span><span>${msg}</span></div>`
                    )
                    .join("") +
                  "</div>"
              : json.errors;
          }
        } catch (err) {
          message = xhr?.responseText || "Erreur serveur";
        }
      
        $("#fx-conteneur-error").remove();
      
        const $flash = $(`
          <div id="fx-conteneur-error" class="fx-flash-top-right fx-flash-error fx-flash-message"
               data-controller="flash"
               data-flash-target="container"
               data-action="mouseenter->flash#mouseenter mouseleave->flash#mouseleave">
            <button class="fx-flash-close-button" data-action="flash#dismissManually">&times;</button>
            <p class="fx-flash-explanation">Merci de corriger les erreurs suivantes :</p>
            ${message}
            <div class="fx-progress-bar" data-flash-target="progressBar"></div>
          </div>
        `);  
 
        $("body").prepend($flash);
      
        
          setTimeout(() => {
            $flash.fadeOut(500, () => $flash.remove());
          }, 5000);
        
      }
      
    };

    if (fieldType === "select" && fieldSource) {
      if (typeof fieldSource === "string") {
        try {
          options.source = JSON.parse(fieldSource);
        } catch (e) {
          if (window[fieldSource]) {
            options.source = window[fieldSource];
          } else {
            console.warn("data-source non exploitable :", $el, e);
          }
        }
      } else if (Array.isArray(fieldSource)) {
        options.source = fieldSource;
      }
    }

    // 💥 La ligne qu'il te manquait :
    $el.editable(options);
  });
}
